import { GlobalStore } from '@/store/global';
import { computed } from 'vue';

export class NoVisaInformationCB {
	public destinationCountryName = computed(() => {
		return GlobalStore.getters.getDestinationCountry()?.name ?? '';
	});

	public originCountryName = computed(() => {
		return GlobalStore.getters.getOriginCountry()?.name ?? '';
	});

	public openLocalizationSettings(): void {
		GlobalStore.actions.openLocalizationSettings();
	}
}
